import useWindowSize from '@rooks/use-window-size';

import config from 'config';

const useBreakpoint = (screen) => {
  const { innerWidth } = useWindowSize();

  const breakpoint = config(`/tw/screens/${screen}`);
  if (!breakpoint) throw new Error(`Unknown breakpoint: ${screen}`);

  return innerWidth >= Number(breakpoint.replace('px', ''));
};

export default useBreakpoint;
